import {DossierItemType} from "const/DossierItemType"

export default {
  title: "Dossier zoeken",
  input: {
    type: {
      label: "Dossier item type",
      option: {
        [DossierItemType.note]: "Notitie",
        [DossierItemType.email]: "Email",
        [DossierItemType.invoice]: "Factuur",
      },
    },
    subject: "Onderwerp"
  }
}
